export default {
  title: 'CheatSheets For All!',
  description: `${''}Here is a collection of my finest cheatSheets I've come to rely on from time to time. They are hosted on GitHub and can be changed or corrected via a pull-request there.`,
  sheets: {
    docker: {
      title: `${''}Docker`,
      description: `${''}Docker commands and guides.`
    },
    gpg: {
      title: `${''}GPG`,
      description: `${''}General commands.`
    },
    hibernation: {
      title: `${''}Scheduled Hibernation`,
      description: `${''}Schedule hibernation and wakeup on a linux machine.`
    },
    keycloak: {
      title: `${''}Keycloak Upgrade From v-pre13`,
      description: `${''}Upgrade a Keycloak server from a very old version (pre 13).`
    },
    letsEncrypt: {
      title: `${''}Let's Encrypt`,
      description: `${''}Step-by-step manual for linux and Nginx.`
    },
    linux: {
      title: `${''}Linux`,
      description: `${''}General-purpose linux-commands for setting up or maintaining computers, Docker installation, partition HDDs, mounting, Samba, NFS...`
    },
    ssh: {
      title: `${''}SSH`,
      description: `${''}Set up SSH with RSA keys on client and server, generate keys, rsync.`
    },
    ssl: {
      title: `${''}SSL`,
      description: `${''}Keystore manipulation, key conversions.`
    },
    vnc: {
      title: `${''}VNC`,
      description: `${''}RDP protocols, servers and clients and installation instructions.`
    }
  }
}
